import CGU from '@/views/footer/cgu'
import MensionsLegales from '@/views/footer/mentions-legales'
import Compte from '@/views/compte'
import MesCultures from '@/views/cultures'
import DetailContrats from '@/views/detail-contrats'
import DetailRecolte from '@/views/detail-recolte'
import OutilsAnalyse from '@/views/outils-analyse'
import DocumentPdf from '@/views/document'
import Faq from '@/views/faq'
import AdminRebond from '@/views/admin/rebond/index.vue'
import AdminComparateurMarge from '@/views/comparateur-marge-admin'
import Login from '@/views/login'
import Main from '@/views/main'
import NotFound from '@/views/error/not-found'
import NotAuthorize from '@/views/error/not-authorize'
import TableauDeBord from '@/views/tableau-de-bord'
import OffresAbonnementAdmin from '@/views/admin/offre-abonnement'
import TemoignagesAbonnementAdmin from '@/views/admin/temoignage'
import OffresAbonnement from '@/views/offre-abonnement'
import FaqAgrial from '@/views/admin/faq'
import Admin from '@/views/admin'
import SimulateurEcoAdmin from '@/views/admin/simulateur-eco'
import ComparateurMargeAdherent from '@/views/comparateur-marge-adherent'
import SaisieContratsAdherent from '@/views/outils-analyse/saisie-contrats'

export default function () {
  return [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/',
      name: 'main',
      component: Main,
      meta: {
        secure: true
      },
      children: [
        {
          path: '',
          redirect: { name: 'main.tableau-de-bord' }
        },
        {
          path: 'tableau-de-bord',
          name: 'main.tableau-de-bord',
          component: TableauDeBord,
          props: true,
          meta: {
            title: 'Accueil'
          }
        },
        {
          path: 'admin',
          name: 'main.admin',
          component: Admin,
          children: [
            {
              path: 'faq',
              name: 'main.admin.faq',
              component: FaqAgrial,
              meta: {
                title: 'Saisir la FAQ',
                permissions: ['CULTURIAL_ECRITURE_PARAM_APPLICATION'],
                breadcrumb: [
                  {
                    name: 'Accueil',
                    link: 'main.tableau-de-bord',
                    icon: 'mdi-home'
                  }]
              }
            },
            {
              path: 'abonnement',
              name: 'main.admin.offre-abonnement',
              component: OffresAbonnementAdmin,
              meta: {
                title: 'Administrer les offres',
                permissions: ['CULTURIAL_ECRITURE_PARAM_APPLICATION'],
                breadcrumb: [
                  {
                    name: 'Accueil',
                    link: 'main.tableau-de-bord',
                    icon: 'mdi-home'
                  }
                ]
              }
            },
            {
              path: 'temoignage',
              name: 'main.admin.temoignage-abonnement',
              component: TemoignagesAbonnementAdmin,
              meta: {
                title: 'Ecrire les témoignages',
                permissions: ['CULTURIAL_ECRITURE_PARAM_APPLICATION'],
                breadcrumb: [
                  {
                    name: 'Accueil',
                    link: 'main.tableau-de-bord',
                    icon: 'mdi-home'
                  }
                ]
              }
            },
            {
              path: 'rebond',
              name: 'main.admin.rebond',
              component: AdminRebond,
              meta: {
                title: 'Paramétrer des rebonds',
                permissions: ['CULTURIAL_ECRITURE_PARAM_APPLICATION'],
                breadcrumb: [
                  {
                    name: 'Accueil',
                    link: 'main.tableau-de-bord',
                    icon: 'mdi-home'
                  }]
              }
            },
            {
              path: 'simulateur-repere-eco',
              name: 'main.admin.simulateur-repere-eco',
              component: SimulateurEcoAdmin,
              meta: {
                title: 'Borner le simulateur éco',
                permissions: ['CULTURIAL_ECRITURE_ADMIN_DTE'],
                breadcrumb: [
                  {
                    name: 'Accueil',
                    link: 'main.tableau-de-bord',
                    icon: 'mdi-home'
                  }
                ]
              }
            },
            {
              path: 'comparateur-marge',
              name: 'main.admin.comparateur-marge',
              component: AdminComparateurMarge,
              meta: {
                title: 'Configurer le comparateur de marge ',
                permissions: ['CULTURIAL_ECRITURE_ADMIN_DTE'],
                breadcrumb: [
                  {
                    name: 'Accueil',
                    link: 'main.tableau-de-bord',
                    icon: 'mdi-home'
                  }]
              }
            }
          ]
        },
        {
          path: 'mes-recoltes',
          name: 'main.mes-recoltes',
          component: DetailRecolte,
          meta: {
            title: 'Mes apports',
            breadcrumb: [
              {
                name: 'Accueil',
                link: 'main.tableau-de-bord',
                icon: 'mdi-home'
              }
            ]
          }
        },
        {
          path: 'mes-contrats',
          name: 'main.mes-contrats',
          component: DetailContrats,
          meta: {
            title: 'Mes contrats',
            breadcrumb: [
              {
                name: 'Accueil',
                link: 'main.tableau-de-bord',
                icon: 'mdi-home'
              }]
          }
        },
        {
          path: 'documents/:numeroContrat',
          name: 'main.mes-documents',
          props: route => ({ numeroContrat: route.params.numeroContrat }),
          component: DocumentPdf,
          meta: {
            title: 'Mes documents',
            breadcrumb: [
              {
                name: 'Accueil',
                link: 'main.tableau-de-bord',
                icon: 'mdi-home'
              }]
          }
        },
        {
          path: 'mes-cultures',
          name: 'main.mes-cultures',
          component: MesCultures,
          meta: {
            title: 'Mes cultures',
            breadcrumb: [
              {
                name: 'Accueil',
                link: 'main.tableau-de-bord',
                icon: 'mdi-home'
              }]
          }
        },
        {
          path: 'mes-cultures/comparateur-marge-adherent',
          name: 'main.comparateur-marge-adherent',
          component: ComparateurMargeAdherent,
          meta: {
            title: 'Comparateur de marges',
            breadcrumb: [
              {
                name: 'Accueil',
                link: 'main.tableau-de-bord',
                icon: 'mdi-home'
              },
              {
                name: 'Mes cultures',
                link: 'main.mes-cultures'
              }
            ]
          },
        },
        {
          path: 'mes-outils-d-analyse',
          name: 'main.mes-outils-d-analyse',
          component: OutilsAnalyse,
          meta: {
            title: 'Mes outils d\'analyse',
            breadcrumb: [
              {
                name: 'Accueil',
                link: 'main.tableau-de-bord',
                icon: 'mdi-home'
              }]
          }
        },
        {
          path: 'saisie-contrats-adherent',
          name: 'main.saisie-contrats-adherent',
          component: SaisieContratsAdherent,
          meta: {
            title: 'Saisir les ventes de l\'adhérent',
            permissions: ['CULTURIAL_ECRITURE_ADMIN_DTE'],
            breadcrumb: [
              {
                name: 'Accueil',
                link: 'main.tableau-de-bord',
                icon: 'mdi-home'
              },
              {
                name: 'Mes outils d\'analyse',
                link: 'main.mes-outils-d-analyse'
              }]
          }
        },
        {
          path: 'compte',
          name: 'main.compte',
          component: Compte,
          meta: {
            title: 'Mon compte',
            breadcrumb: [
              {
                name: 'Accueil',
                link: 'main.tableau-de-bord',
                icon: 'mdi-home'
              }]
          }
        },
        {
          path: 'mentions-legales',
          name: 'main.mentions-legales',
          component: MensionsLegales,
          meta: {
            title: 'Mentions légales',
            breadcrumb: [
              {
                name: 'Accueil',
                link: 'main.tableau-de-bord',
                icon: 'mdi-home'
              }]
          }
        },
        {
          path: 'cgu',
          name: 'main.cgu',
          component: CGU,
          meta: {
            title: 'CGU',
            breadcrumb: [
              {
                name: 'Accueil',
                link: 'main.tableau-de-bord',
                icon: 'mdi-home'
              }]
          }
        },
        {
          path: 'faq',
          name: 'main.faq',
          component: Faq,
          meta: {
            title: 'FAQ',
            breadcrumb: [
              {
                name: 'Accueil',
                link: 'main.tableau-de-bord',
                icon: 'mdi-home'
              }]
          }
        },
        {
          path: 'abonnement',
          name: 'main.offre-abonnement',
          component: OffresAbonnement,
          meta: {
            title: 'Abonnement',
            breadcrumb: [
              {
                name: 'Accueil',
                link: 'main.tableau-de-bord',
                icon: 'mdi-home'
              }
            ]
          }
        }
      ]
    },
    {
      path: '*',
      meta: {
        title: 'Page Introuvable'
      },
      name: 'not-found',
      component: NotFound
    },
    {
      path: '/not-authorize',
      meta: {
        title: 'Accès interdit'
      },
      name: 'unauthorized',
      component: NotAuthorize
    }
  ]
}
